import React from 'react';
import styled from 'styled-components';

import { MoreStyle as Wrapper } from './Detail';

import { FONT } from '../../../styles/color';
import productsList from '../../../assets/imgs/productList.png';

const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0;
`;

const Button = styled.button`
	width: 50%;
	height: 75px;
	background-color: transparent;
	cursor: pointer;
	font: normal 350 20px Pretendard Variable;
	color: ${ FONT.default };
	border: none;
	border-bottom: ${ (props) => ((props.$isSelected) ? (`3px solid ${ FONT.default }`) : 'none') };
	box-sizing: content-box;
`;

const Content = styled.div`
	width: 100%;
	display: ${ (props) => (props.$isSelected ? 'block' : 'none')} ;
`;

export default function More(props) {
	const [selectedMenu, setSelectedMenu] = React.useState(0);

	const onMenuClick = (key) => {
		setSelectedMenu(key);
	};
	
  	return (
		<Wrapper>
			<ButtonWrapper>
				<Button $isSelected={selectedMenu === 0} onClick={() => onMenuClick(0)}>상품정보</Button>
				<Button $isSelected={selectedMenu === 1} onClick={() => onMenuClick(1)}>사이즈 비교</Button>
			</ButtonWrapper>
				<Content $isSelected={selectedMenu === 0}>
					<img src={props.detailImage} width="100%"/>
				</Content>
				<Content $isSelected={selectedMenu === 1}>
					<img src={productsList} width="100%"/>
				</Content>
		</Wrapper>
  	);
}
